var amdi18n={"__root":{"alerts":"Alerts","dismiss":"Dismiss"},"__cs":{"alerts":"Výstrahy","dismiss":"Opustit"},"__da":{"alerts":"Varsler","dismiss":"Afvis"},"__de":{"alerts":"Alerts","dismiss":"Schließen"},"__es":{"alerts":"Alertas","dismiss":"Descartar"},"__fi":{"alerts":"Hälytykset","dismiss":"Ohita"},"__fr":{"alerts":"Alertes","dismiss":"Fermer"},"__hr":{"alerts":"Uzbune","dismiss":"Odbaci"},"__hu":{"alerts":"Riasztások","dismiss":"Elvetés"},"__it":{"alerts":"Avvisi","dismiss":"Rimuovi"},"__ja":{"alerts":"アラート","dismiss":"解放"},"__kk":{"alerts":"Ескертулер","dismiss":"Бас тарту"},"__ko":{"alerts":"경고","dismiss":"닫기"},"__nb":{"alerts":"Varsler","dismiss":"Avvis"},"__nl":{"alerts":"Alerts","dismiss":"Verwijderen"},"__no":{"alerts":"Varsler","dismiss":"Avvis"},"__pl":{"alerts":"Alerty","dismiss":"Zamknij"},"__pt":{"alerts":"Alertas","dismiss":"Indeferir"},"__pt-br":{"alerts":"Alertas","dismiss":"Indeferir"},"__ro":{"alerts":"Alerte","dismiss":"Renunţare"},"__ru":{"alerts":"Оповещения","dismiss":"Отбросить"},"__sl":{"alerts":"Opozorila","dismiss":"Opusti"},"__sv":{"alerts":"Varningar","dismiss":"Avvisa"},"__th":{"alerts":"แจ้งเตือน","dismiss":"ยกเลิก"},"__tr":{"alerts":"Uyarılar","dismiss":"Kapat"},"__zh":{"alerts":"警报","dismiss":"关闭"},"__zh-cn":{"alerts":"警报","dismiss":"关闭"},"__zh-hk":{"alerts":"警示","dismiss":"跳出"},"__zh-mo":{"alerts":"警示","dismiss":"跳出"},"__zh-sg":{"alerts":"警报","dismiss":"关闭"},"__zh-tw":{"alerts":"警示","dismiss":"跳出"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;